<template>
  <div class="remote-consultation clearfix">
    <div class="remote-consultation-wrap">
      <div class="tab_change">
        <button
          :class="[{ active: activeName == 'record' }]"
          @click="changeTab('record')"
        >
          就诊记录
        </button>
        <button
          :class="[{ active: activeName == 'prescription' }]"
          @click="changeTab('prescription')"
        >
          开处方
        </button>
        <button
          :class="[{ active: activeName == 'medicalRecord' }]"
          @click="changeTab('medicalRecord')"
        >
          写病历
        </button>
        <button
          :class="[{ active: activeName == 'HealthData' }]"
          @click="changeTab('HealthData')"
        >
          居家健康数据
        </button>
      </div>
      <div class="tabLine-content">
        <div v-if="activeName == 'record'">
          <record></record>
        </div>
        <div v-else-if="activeName == 'prescription'">
          <prescription :userobj="userobj"></prescription>
        </div>
        <div v-else-if="activeName == 'medicalRecord'">
          <medicalRecord :userobj="userobj"></medicalRecord>
        </div>
        <div v-else-if="activeName == 'HealthData'" style="width: 100%">
          <HealthData :userobj="userobj"></HealthData>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import record from "./record.vue";
import medicalRecord from "./medicalRecord.vue";
// import prescription from "../prescription-management/EPrescription.vue";
import prescription from "../prescription-management/newEPrescription.vue";
import HealthData from "./HealthData.vue";
export default {
  data: function () {
    return {
      activeName: "record", //切换标签的值
      userobj: {},
    };
  },
  components: {
    record,
    medicalRecord,
    prescription,
    HealthData,
  },
  created() {
    this.userobj = JSON.parse(localStorage.getItem("userobj"));
  },
  mounted: function () {},
  methods: {
    changeTab: function (tab) {
      //标签切换
      this.activeName = tab;
    },
  },
  beforeDestroy(){
    window.sessionStorage.removeItem("userobj");
  }
};
</script>
<style>
.remote-consultation-wrap .tab_change button {
  width: 140px;
  height: 42px;
  line-height: 42px;
  background-color: #f1f1f1;
  color: #cecccd;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  font-weight: bold;
}
.active {
  background-color: #409eff !important;
  color: #ffffff !important;
}
</style>
